import type { DateTime } from "luxon";

export type DateTimeProperties = {
	timezone?: string | null;
	locale?: string | null;
};

export function useDateTimeUtils() {
	function setTimezone(dateTime: DateTime, timezone?: string | null) {
		if (!timezone) return dateTime;

		const newDateTime = dateTime.setZone(timezone);
		if (!newDateTime.isValid) return dateTime;

		return newDateTime;
	}

	function setLocale(dateTime: DateTime, locale?: string | null) {
		if (!locale) return dateTime;

		try {
			const newDateTime = dateTime.setLocale(locale);

			// toLocalString throw error if the locale is invalid
			newDateTime.toLocaleString();

			return newDateTime;
		} catch (e) {
			if (e instanceof RangeError) {
				return dateTime;
			}

			throw e;
		}
	}

	function updateDateTimeProperties(dateTime: DateTime, properties: DateTimeProperties) {
		dateTime = setTimezone(dateTime, properties.timezone);
		dateTime = setLocale(dateTime, properties.locale);

		return dateTime;
	}

	function dateTimeEquals(d1: Date | DateTime, d2: Date | DateTime) {
		return d1.valueOf() === d2.valueOf();
	}

	return { updateDateTimeProperties, dateTimeEquals };
}
